import type { Catch } from "@kalaporssi/engine";
import { speciesById } from "@kalaporssi/shared";
import type { ReactNode } from "react";
import { feur, fkg } from "../lib/format";

/** A catch drawn like a crate label. */
export function CatchCard(props: {
  c: Catch;
  onSelect?: () => void;
  selected?: boolean;
  mine?: boolean;
  footer?: ReactNode;
}) {
  const { c } = props;
  const inner = (
    <>
      <div className="row spread">
        <span className="no">#{c.number}</span>
        <span className="place">{c.place}</span>
      </div>
      <ul>
        {c.items.map((it) => {
          const s = speciesById[it.speciesId];
          return (
            <li key={it.speciesId}>
              <span>
                <span className="chip" style={{ background: s?.color }} />
                {s?.name ?? it.speciesId}
              </span>
              <span className="num">{fkg(it.kg)}</span>
            </li>
          );
        })}
      </ul>
      <div className="val num">Ennustearvo {feur(c.forecastValue)}</div>
      {props.footer}
    </>
  );
  const cls = `crate${props.selected ? " sel" : ""}${props.mine ? " mine" : ""}`;
  if (props.onSelect) {
    return (
      <button type="button" className={cls} onClick={props.onSelect} aria-pressed={props.selected ?? false}>
        {inner}
      </button>
    );
  }
  return <div className={cls}>{inner}</div>;
}
